/**
 * Collection Dashboard V1 API permissions (design §15.2).
 */

export const COLLECTION_DASHBOARD_READ_PERMISSION = 'collection_dashboard:read' as const;

export const COLLECTION_DASHBOARD_PERMISSIONS = [COLLECTION_DASHBOARD_READ_PERMISSION] as const;

export type CollectionDashboardPermission = (typeof COLLECTION_DASHBOARD_PERMISSIONS)[number];

export function isCollectionDashboardPermission(
  permission: string
): permission is CollectionDashboardPermission {
  return (COLLECTION_DASHBOARD_PERMISSIONS as readonly string[]).includes(permission);
}
